import RequestProductFormModel from './model/form.model.js';
import RequestProductSuccessModalModel from './model/success.modal.model';
import { showModal } from '@shared/ui/modal.util';

const POSITION_TAKING_PRODUCT_CODES = ['SIN', 'MXB', 'SBO','ORB','WIC', 'MTB'];
const MEMBER_PRODUCT_REQUEST_STORAGE_KEY = 'requested_products';

class RequestProductController {
    constructor(ProductApiService, CustomerApiService, StorageService, MemberProductApiService, AppService, $timeout) {
        'ngInject';

        this.unrequestedProducts = {};
        this.requestedProducts = {};
        this.products = null;
        this.memberProducts = null;
        this.isDisabled = true;
        this.hasUnrequestedProducts = null;
        this.hasAgreement = false;

        this.$timeout = $timeout;
        this.StorageService = StorageService;
        this.ProductApiService = ProductApiService;
        this.CustomerApiService = CustomerApiService;
        this.MemberProductApiService = MemberProductApiService;
        this.AppService = AppService;
    }

    $onInit() {
        this.requestProductSuccessModal = new RequestProductSuccessModalModel();
        this.form = new RequestProductFormModel();

        this.getUnrequestedProducts();
    }

    getUnrequestedProducts() {
        const productsPromise = this.ProductApiService.getProducts();
        const memberProductsPromise = this.CustomerApiService.getCustomerProducts();

        Promise.all([productsPromise, memberProductsPromise]).then((values) => {
            this.unrequestedProducts = {};
            this.products = values[0];
            this.memberProducts = values[1];

            angular.forEach(this.products, (product) => {
                let found = false;

                angular.forEach(this.memberProducts, (memberProduct) => {
                    if (product.code == memberProduct.product.code) {
                        found = true;
                    }
                });

                if (!found && product.can_be_requested) {
                    this.unrequestedProducts[product.code] = product;
                }
            });

            this.checkUnrequestedProducts();
        });
    }

    hasPositionTaking(code) {
        if (!angular.isUndefined(this.form.getRequestProduct(code))) {
            return this.form.getRequestProduct(code).isSelected;
        }

        return false;
    }

    toggleTab(code) {
        this.$timeout(() => {
            if (POSITION_TAKING_PRODUCT_CODES.includes(code)) {
                $('#' + code + '-pt').collapse('show');

                if (!angular.isUndefined(this.form.getRequestProduct(code))) {
                    if (this.form.getRequestProduct(code).isAgree) {
                        $('#' + code + '-pt').collapse('hide');
                    }
                }
            }

            angular.forEach(POSITION_TAKING_PRODUCT_CODES, (ptCode) => {
                if (!angular.isUndefined(this.form.getRequestProduct(ptCode))) {
                    if (!this.form.getRequestProduct(ptCode).isAgree) {
                        $('#' + ptCode + '-pt').collapse('show');
                    } else {
                        $('#' + ptCode + '-pt').collapse('hide');
                    }
                }
            });
        }, 100);

        this.toggleSubmitButton();
    }

    toggleSubmitButton() {
        this.$timeout(() => {
            this.hasAgreement = false;
            this.isDisabled = true;
            let productCount = 0;
            let hasEmptyUsername = false;
            let hasAgreed = true;

            angular.forEach(POSITION_TAKING_PRODUCT_CODES, (code) => {
                if (this.hasPositionTaking(code)) {
                    this.hasAgreement = true;
                }
            });

            angular.forEach(this.form.getRequestProducts(), (requestProduct, code) => {
                if (angular.isDefined(this.unrequestedProducts[code])) {
                    if (requestProduct.isSelected) {
                        productCount += 1;

                        if (this.unrequestedProducts[code].has_username && !hasEmptyUsername &&
                            (angular.isUndefined(requestProduct.username) || requestProduct.username.length == 0)) {
                            hasEmptyUsername = true;
                        }

                        if (this.hasAgreement && POSITION_TAKING_PRODUCT_CODES.includes(code) && !requestProduct.isAgree) {
                            hasAgreed = false;
                        }
                    } else {
                        if (POSITION_TAKING_PRODUCT_CODES.includes(code)) {
                            requestProduct.isAgree = false;
                        }
                    }
                }
            });

            if (productCount > 0) {
                this.isDisabled = false;

                if (hasEmptyUsername) {
                    this.isDisabled = true;
                }

                if (this.hasAgreement && !hasAgreed) {
                    this.isDisabled = true;
                }
            }
        }, 100);
    }

    reset() {
        this.form.setRequestProducts({});
        this.form.setFormErrors([]);
        this.isDisabled = true;
        this.hasAgreement = false;
    }

    checkUnrequestedProducts() {
        if (Object.keys(this.unrequestedProducts).length > 0) {
            this.hasUnrequestedProducts = true;
        } else {
            this.hasUnrequestedProducts = false;
        }
    }

    submit() {
        this.MemberProductApiService.request(this.form.toPayload())
            .then((response) => {
                this.getRequestedProducts(response);
                this.requestProductSuccessModal.requestedProducts = response;
                this.StorageService.setItem(MEMBER_PRODUCT_REQUEST_STORAGE_KEY, JSON.stringify(this.requestedProducts));
                this.removeUnrequestedProducts();
                this.AppService.broadcast('reload.member-product-list');
                $('#requestProductModal').modal('hide');
                this.reset();

                showModal('requestProductSuccessModal');
            })
            .catch((errors) => {
                this.form.setFormErrors(errors);

                if (this.StorageService.hasItem(MEMBER_PRODUCT_REQUEST_STORAGE_KEY)) {
                    this.requestedProducts = JSON.parse(this.StorageService.getItem(MEMBER_PRODUCT_REQUEST_STORAGE_KEY));
                    this.removeUnrequestedProducts();
                }

                this.toggleSubmitButton();
            })
        ;
    }

    close() {
        this.reset();
    }

    removeUnrequestedProducts() {
        angular.forEach(this.requestedProducts, (productCode) => {
            if (angular.isDefined(this.unrequestedProducts[productCode])) {
                delete this.unrequestedProducts[productCode];

                if (angular.isDefined(this.form.requestProducts[productCode])) {
                    delete this.form.requestProducts[productCode];
                }
            }
        });

        this.checkUnrequestedProducts();
    }

    getRequestedProducts(memberProducts) {
        if (this.StorageService.hasItem(MEMBER_PRODUCT_REQUEST_STORAGE_KEY)) {
            this.requestedProducts = JSON.parse(this.StorageService.getItem(MEMBER_PRODUCT_REQUEST_STORAGE_KEY));
        }

        angular.forEach(memberProducts, (memberProduct) => {
            this.requestedProducts[memberProduct.id] = memberProduct.product.code;
        });
    }
}

export default RequestProductController;



// WEBPACK FOOTER //
// ./client/app/shared/system-components/request-product/request-product.modal.controller.js